import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/HeroSection';
import CourseSection from '../components/CourseSection';
import BookSection from '../components/BookSection';
import TestimonialsSection from '../components/TestimonialsSection';
import MediaSection from '../components/MediaSection';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <CourseSection />
      <BookSection />
      <TestimonialsSection />
      <MediaSection />
      <Footer />
    </div>
  );
};

export default Home;
